module.exports = __webpack_public_path__ + "static/media/technology_cn2.aa3576f6.png";